$(function() {
  $('[data-toggle="tooltip"]').tooltip();
});

$(function() {
  $('[data-toggle="popover"]').popover();
});

$(document).ready(function() {
  $('form#aspire-files-form').on("submit", function(e) {
    $('#importModal .close').click();
  });
});
